const LoadingStatus = Object.freeze({
	None: 'none',
	Started: 'started',
	Completed: 'completed',
});

export default LoadingStatus;
